import React from "react";
import { createPortal } from "react-dom";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { useUIStore } from "../stores/uiStore";
import "./toaster.css";

const Toaster = (props: ToasterProps) => {
  const applicationTheme = useUIStore((state) => state.theme);
  const documentDirection =
    typeof document !== "undefined" ? document.documentElement.dir : "";
  const direction =
    props.dir ||
    (documentDirection === "rtl" || documentDirection === "auto"
      ? documentDirection
      : "ltr");
  const toaster = (
    <div data-ui-toast-root="" dir={direction}>
      <Sonner
        theme={applicationTheme}
        className="toaster group"
        richColors
        position="bottom-right"
        dir={direction}
        visibleToasts={1}
        toastOptions={{
          classNames: {
            toast:
              "group toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
            description: "group-[.toast]:text-muted-foreground",
            actionButton:
              "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
            cancelButton:
              "group-[.toast]:bg-secondary group-[.toast]:text-secondary-foreground",
          },
        }}
        {...props}
      />
    </div>
  );

  if (typeof document === "undefined") return toaster;

  return createPortal(toaster, document.body);
};

export { Toaster };
